import React, { Component } from 'react';
import store from '../store';
import { RESET_CITY, FILE_IMAGES, typeList, showTimeList, LBFormulaList, LBFormulaList2, answerTimeList, qCountList, maxNumberList, digitsList, YesNoList, typeCatList } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';
import '../style/mycss.css';
import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import InputLabel from '@material-ui/core/InputLabel';
import ButtonBase from '@material-ui/core/ButtonBase';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { Redirect } from 'react-router-dom';
import Numpad from "./Numpad"
import NumDisplay from "./NumDisplay"
import CountDown from "./CountDown"
import firebase from "firebase/app";
import "firebase/firestore";
import * as STATIC from '../config/static';
import _ from 'lodash'
import Modal from 'react-responsive-modal';
const DWIDTH = 480;
const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    backgroundImage: "url('assets/images/bg.jpg')",
    backgroundPosition: "center center",
    backgroundAttachment: "fixed",
    WebkitBackgroundSize: "cover",
    backgroundSize: "cover",
    overflow: 'hidden',
    position: 'absolute',
    display: 'table',
    height: '100%',
    width: '100%',
    color: '#1B5E20'
  },
  middle: {
    display: 'table-cell',
    verticalAlign: 'top',
    padding: "0 5px",
  },
  square: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: DWIDTH,
    padding: theme.spacing.unit * 2,
    borderRadius: '20px',
    backgroundColor: '#c5e0b5',
    marginTop: 5,
    marginBottom: 10
  },
  textField: {
    minWidth: 200,

  }, container: {
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "10px"
  }, chips: {
    display: 'flex',
    flexWrap: 'wrap',

  },
  chip: {
    margin: 2,
    backgroundColor: '#538234',
    color: 'white'
  },
});
let imageList = [
  'assets/images/finger/0.png',
  'assets/images/finger/1-01.png',
  'assets/images/finger/2-01.png',
  'assets/images/finger/3-01.png',
  'assets/images/finger/4-01.png',
  'assets/images/finger/5-01.png',
  'assets/images/finger/6-01.png',
  'assets/images/finger/7-01.png',
  'assets/images/finger/8-01.png',
  'assets/images/finger/9-01.png',
  'assets/images/finger/10-01.png',
  'assets/images/finger/20-01.png',
  'assets/images/finger/30-01.png',
  'assets/images/finger/40-01.png',
  'assets/images/finger/50-01.png',
  'assets/images/finger/60-01.png',
  'assets/images/finger/70-01.png',
  'assets/images/finger/80-01.png',
  'assets/images/finger/90-01.png',
  'assets/images/soroban/soroban.png',
  'assets/images/soroban/sline.png',
  'assets/images/soroban/dot.png',
]

function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};
function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
function isInt(n) { return parseInt(n) === n };
let _this;
class LessonComp extends Component {
  constructor(props) {
    super(props);
    _this = this;
    this.state = {
      type: props.type ? props.type : ['image'],

      rows: props.rows ? props.rows : 3,
      showTime: props.showTime ? props.showTime : 6,
      answerTime: props.answerTime ? props.answerTime : 6,
      qCount: props.qCount ? props.qCount : 5,
      maxNumber: props.maxNumber ? props.maxNumber : 10,
      digits: props.digits ? props.digits : 1,
      digits1: props.digits1 ? props.digits1 : 1,
      digits2: props.digits2 ? props.digits2 : 1,
      minDigits: props.minDigits ? props.minDigits : 1,
      maxDigits: props.maxDigits ? props.maxDigits : 3,
      roundNumber: props.roundNumber ? props.roundNumber : 0,
      largerThan: props.largerThan ? props.largerThan : 0,
      displaySetting: props.displaySetting ? props.displaySetting : 0,
      displayShow: props.displayShow ? props.displayShow : 1,
      lessThan0: props.lessThan0 ? props.lessThan0 : 0,
      isReversed: props.isReversed ? props.isReversed : 0,
      enableSound: props.enableSound ? props.enableSound : 0,
      dr1: props.dr1 ? props.dr1 : 0,
      dr2: props.dr2 ? props.dr2 : 0,
      dba: props.dba ? props.dba : 1,
      ssp: props.ssp ? props.ssp : 0,
      wWidth: 0,
      wHeight: 0,
      answerInput: '',
      showEq: false,
      curIndex: 0,
      questions: [],
      showing: false,
      showCountDown: false,
      message: '',
      showSetting: false,
      starting: false, showEQMessage: '',
      showSetting2:false,
      showSSP:false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    //event.preventDefault();
    //console.log(event.target.value);
    this.setState({
      [name]: event.target.value

    });

  }
  handleChangeDigits = (name,max) => event => {

    let value = event.target.value;
    if(value>max)
    {
      value=max;
    }

    this.setState({
      [name]: value
    });

  }
  handleChangeNumber = (name,max,min) => event => {
    if(event.target.value>max||event.target.value<1||event.target.value<min)
    {
      return this.forceUpdate();
    }

    this.setState({
      [name]: event.target.value

    });

  }
  handleKeypress = event => {

    if (event.key === "Enter") {
      _this.confirmAnswer();
    }
  }

  handleDelete = (name, value) => {
    let change = _this.state[name];

    change = _.without(change, value);

    this.setState({
      [name]: change
    });
  }

  componentDidMount() {
    //console.log('test',_this.getRandomFormula('LB_3'));
    // console.log('LB',this.checkLB(8,-5));
    imageList.forEach(image=>{
      new Image().src = image;
    })
    if (this.props.showAdvance) {
      this.setState({ showSetting: true })

    }
    else if(this.state.ssp==1)
    {
      this.setState({ showSSP: true })
    }
    _this.setState({sAudio:(new Audio("assets/sound/success.mp3")),fAudio:(new Audio("assets/sound/fail2.mp3")),yAudio:(new Audio("assets/sound/yay.mp3"))});

    //console.log(isMobileDevice());
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.updateTitle();
  }
  updateTitle() {
    if (this.props.updateTitle) {
      this.props.updateTitle(this.state.digits + "D/" + this.state.rows + "R/" + this.state.showTime + "S/" + this.getFormularName());
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }

  handleInputClick(value) {
    if (_this.state.showing || _this.state.message || _this.state.questions.length == 0) {
      //  _this.setState({answerInput});
      return;
    }
    let answerInput = _this.state.answerInput;
    if (value == 'Enter') {
      _this.confirmAnswer();
    }
    else
      if (value != "-1") {
        if (answerInput.length < 7)
          answerInput += value;
        _this.setState({ answerInput });
      }
      else {
        if (answerInput.length > 0) {
          answerInput = answerInput.slice(0, -1);
          _this.setState({ answerInput });
        }
      }
_this.answerInput.focus();
  }

  async startLesson() {
    if (_this.state.processing == true) {
      return;
    }
    if (_this.state.starting == true) {
      if (_this.props.onLessonEnd) {
        _this.props.onLessonEnd(_this.state.questions);
      }
      _this.setState({answering:false, showCountDown: false, showing: false, message: '', answerInput: '', questions: [], starting: false, curIndex: 0 });

      return;
    }
    await _this.setState({processing:true});

    //console.log(_this.randomQuestionList(_this.state.qCount));
    let questions = _this.randomQuestionList(_this.state.qCount);

    // console.log(questions);
    // return;
    if (questions && questions.length > 0)
      _this.setState({answering:false, showCountDown: false, trial: false, questions, starting: true, curIndex: 0, answerInput: '', message: '' }, () => this.progressQuestion());
      await _this.setState({processing:false});
  }
  async startTrial() {
    if (_this.state.processing == true) {
      return;
    }
    if (_this.state.starting == true) {


      return;
    }
    this.updateTitle();
    await _this.setState({processing:true});
    let questions = _this.randomQuestionList(1);
    if (questions && questions.length > 0)
      _this.setState({ showCountDown: false, trial: true, questions, starting: true, curIndex: 0, answerInput: '', message: '' }, () => this.progressQuestion());
      await _this.setState({processing:false});

  }

  checkLB(t, value) {
    t=t%10;
    if (t > 0 && t < 5 && value > 0 && value < 5 && t + value >= 5 && t + value < 10) {
      return true;
    }
    if (t >= 5 && t < 10 && t + value > 0 && t + value < 5 && value > -5) {
      return true;
    }
    return false;
  }
  checkBB(t, value) {
    if (t > 0 && (t % 10) + value >= 10) {
      return true;
    }
    if (_this.state.lessThan0) {
      if (t >= 0 && t < 10 && t + value < 0) {
        return true;
      }
    }
    else {
      if (t >= 10 && (t % 10) + value < 0) {
        return true;
      }
    }

    return false;
  }
  // getNumbersWithFormula(t, number = 0, last = false, lbNumb = 0) {
  //   let index = -9;
  //   let relArr = [];
  //   //console.log(lbNumb);
  //
  //   for (index; index < 10; index++) {
  //     if ((lbNumb > 0 && index < 0) || (lbNumb < 0 && index > 0) || t + index < -9) {
  //       continue;
  //     }
  //     if (number == 0) {
  //       if (!_this.checkLB(t, index) && !_this.checkBB(t, index)) {
  //         if (!last)
  //           relArr.push(index);
  //         else {
  //           if (t + index >= 0) {
  //             relArr.push(index);
  //           }
  //         }
  //       }
  //     }
  //     else if ((number < 5 && number > 0) || (number > -5 && number < 0)) {
  //
  //       if (!_this.checkLB(t, index) && !_this.checkBB(t, index) && _this.checkLB(t + index, number) && !_this.checkBB(t + index, number)) {
  //         relArr.push(index);
  //       }
  //     }
  //
  //   }
  //   return relArr;
  // }
  getNumbersForLB(t, lbNumb = 0, last = false) {
    let index = -9;
    let relArr = [];
    //console.log(lbNumb);

    for (index; index < 10; index++) {

      if (last) {
        if (t + index >= 0) {
          relArr.push(index);
        }
        else
          continue;
      }
      if ((lbNumb > 0 && lbNumb < 5) || (lbNumb < 0 && lbNumb > -5)) {
        if (_this.checkLB(t + index, lbNumb)) {
          relArr.push(index);
        }
        else {
          continue;
        }
      }
      else {
        relArr.push(index);
      }



    }
    return relArr;
  }
  getNumbersList(t, lbNumb = 0, last = false, type = 'LB') {
    let index = -9;
    let relArr = [];
    //console.log(lbNumb);

    for (index; index < 10; index++) {

      if (last) {
        if (t + index >= 0) {
          relArr.push(index);
        }
        else
          continue;
      }
      if (type == "LB" && ((lbNumb > 0 && lbNumb < 5) || (lbNumb < 0 && lbNumb > -5))) {
        if (_this.checkLB(t + index, lbNumb)) {
          relArr.push(index);
        }
        else {
          continue;
        }
      }
      else
        if ((lbNumb > 0 && lbNumb < 10) || (lbNumb < 0 && lbNumb > -10)) {
          if (_this.checkBB(t + index, lbNumb)) {
            if (lbNumb > 5) {
              if (type == "BB") {
                if (!_this.checkLB(t + index, (-10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
              else {
                //console.log(10-lbNumb);
                if (_this.checkLB(t + index, (-10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
            }
            else if (lbNumb < -5) {
              if (type == "BB") {
                if (!_this.checkLB(t + index, (10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
              else {
                //console.log(t+index,(10-lbNumb));
                if (_this.checkLB(t + index, (10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
            }
            else {
              relArr.push(index);
            }
          }
          else {
            continue;
          }
        }

        else {
          relArr.push(index);
        }



    }
    return relArr;
  }


  getFormulaList(type) {
    let typeObject = _.find(typeList,{value:type});
    let index = LBFormulaList.findIndex(t=>t==typeObject.fvalue);
    if(_this.state.isReversed)
    {
      index = LBFormulaList2.findIndex(t=>t==typeObject.fvalue);
    }
    //console.log(type,index);
    let relArr = [];
    if (index > -1) {
      for (let nIndex = 0; nIndex <= index; nIndex++) {
        if(_this.state.isReversed)
        {
          relArr.push(LBFormulaList2[nIndex]);
        }
        else
        relArr.push(LBFormulaList[nIndex]);
      }
    }

    return relArr;
  }
  // getRandomFormula(type) {
  //   let index = typeList.findIndex(t => t.value == type);
  //
  //
  //   let relArr = [];
  //   if (index > -1) {
  //     for (let nIndex = 0; nIndex < index; nIndex++) {
  //       relArr.push(LBFormulaList[nIndex]);
  //     }
  //   }
  //   if (relArr.length > 0) {
  //
  //     return _.sample(relArr);
  //   }
  //   return null;
  // }

  filterNumbersWithList(total, list, numbers) {
    let relArr = []
    for (let f of list) {
      let tArr = numbers.filter(n => {
        if (f == 0) {
          //  console.log('check',total,n,_this.checkLB(total,n));

          //return !_this.checkLB(total,n)&&!this.checkBB(total,n)&&total+n>=0&&n!=0;
          if (this.state.digits > 1)
            return !_this.checkLB(total, n) && !this.checkBB(total, n) && total + n >= 0;
          return !_this.checkLB(total, n) && !this.checkBB(total, n) && total + n >= 0 && n != 0;
        }
        else {
          if (f < 5 && f > -5 && isInt(f)) {

            return _this.checkLB(total, n) && n == f && !this.checkBB(total, n);
          }
          else {

            return _this.checkBB(total, n) && n == parseInt(f);
          }

        }
        return false;
      })

      relArr = _.union(relArr, tArr);
    }
    return relArr;
  }
  generateItemForLB2(item, lbNumb, type) {
    let { maxNumber, rows, digits, lessThan0,largerThan,roundNumber } = _this.state;
    item.result = _.random(maxNumber - 1);
    item.numbers = [];
    let total = 0;
    let nIndex = 0;
    let nTotal = [];

    let position = _.random(1, rows - 1);
    if ((type == "BB"||type == "L&B") && ((lessThan0 && lbNumb == -1) || (!lessThan0 && lbNumb < 0)))
      position = _.random(2, rows - 1);

    let vposition = _.random(0, digits - 1);
    if((type=='BB'||type=='L&B')&&largerThan==0)
    {
      if(digits>=2)
      vposition = _.random(0, digits - 2);
    }
    if(roundNumber==1)
    {
      largerThan = 1;
      vposition = digits-1;
    }


    //console.log("position",position,vposition);
    let fArray = [];
    for(let rIndex=0;rIndex<digits;rIndex++)
    {
      fArray.push([]);
      nTotal.push(0);
    }


    for (let tIndex = 0; tIndex < rows; tIndex++) {
      if (position == tIndex) {
        fArray[0].push(lbNumb);
      }
      else
        fArray[0].push(0);
        for(let rIndex=1;rIndex<digits;rIndex++)
        {
          fArray[rIndex].push(0);
        }
    }
    //console.log(fArray[0]);
    let formulaList = _this.getFormulaList(item.type);
    //console.log(item.type,position);
    for (nIndex; nIndex < rows; nIndex++) {

      let rNumber = [];
      for(let rIndex=0;rIndex<digits;rIndex++)
      {
        rNumber.push(0);
      }

      let numbers = [];
      //let temp_nTotal = nTotal;
      let next = fArray[0][nIndex + 1] ? fArray[0][nIndex + 1] : 0;
      let next01=next;
      let next2 = fArray[0][nIndex + 2] ? fArray[0][nIndex + 2] : 0;
      let next02=next2;
      let current = fArray[0][nIndex];
    //  console.log("total",total,nIndex,next2);
      //console.log(next,next2,next3);
      if (current != 0) {

        numbers = [current];

      }
      else {
        if (next != 0) {
          numbers = _this.getNumbersList(nTotal[0], next, 0, type)
        }
        else {
          if (nIndex == rows - 1) {
            numbers = _this.getNumbersList(nTotal[0], next, true, type)
          }
          else {
            numbers = _this.getNumbersList(nTotal[0], next, 0, type)
          }

        }
      }
      //console.log(1,numbers);
      numbers = _this.filterNumbersWithList(nTotal[0], formulaList, numbers);
      //console.log(2,numbers);
      numbers = numbers.filter(n => {
        let tnumbers = _this.getNumbersList(nTotal[0] + n, next2, 0, type);

        tnumbers = _this.filterNumbersWithList(nTotal[0] + n, formulaList, tnumbers);
        //console.log(tnumbers);
        return tnumbers.length > 0 ? true : false;
        //return nTotal+n<5&&nTotal+n>=0&&nTotal+n>=-4-next2;
      })

      if (nIndex == 0) {
        numbers = numbers.filter(n => n > 0);
      }
      if((type=='BB'||type=='L&B')&&largerThan==0)
      {
          if(vposition==digits-2)
          {
            //console.log(nIndex,1,next,nTotal[0],numbers);

            if(next2!=0||next!=0)
            {
              //console.log("next",next2,next);
              if((total>80&&next2!=0)||(total>90&&next!=0))
              {
              //  console.log('test',numbers,nTotal[0]);
                numbers = numbers.filter(n => n<=0);
              //  console.log('test',numbers,nTotal[0]);
              }
              else {
              //  console.log('test1',numbers,nTotal[0]);
                numbers = numbers.filter(n => total+n<=(next2!=0?80:90));
              //  console.log('test1',numbers,nTotal[0]);
              }

            }
            else {
              //  console.log('test12',numbers,nTotal[0]);
              numbers = numbers.filter(n => (nTotal[0]+n)+(nTotal[vposition+1])*10<100||n<=0);
              //console.log('test12',numbers,nTotal[0]);
            }

          //  console.log(nIndex,2,next,nTotal[0],numbers);
          }
      //  numbers = numbers.filter(n => nTotal[0]+n <20);
      }

      rNumber[0] = _.sample(numbers);
      nTotal[0] += rNumber[0];
      for(let rIndex=1;rIndex<digits;rIndex++)
      {
        if(roundNumber==1)
        {
          rNumber[rIndex] = 0;
          nTotal[rIndex] += 0;
          continue;
        }
        numbers=[];
        let next = 0;
        let next2 = 0;
        let current = fArray[rIndex][nIndex];
        if (current != 0) {
          numbers = [current];
        }
        else {
          if (next != 0) {
            numbers = _this.getNumbersForLB(nTotal[rIndex], next, 0, type)
          }
          else {
            if (nIndex == rows - 1) {
              numbers = _this.getNumbersForLB(nTotal[rIndex], next, true, type)
            }
            else {
              numbers = _this.getNumbersForLB(nTotal[rIndex], next, 0, type)
            }

          }
        }
        numbers = _this.filterNumbersWithList(nTotal[rIndex], formulaList, numbers);
        numbers = numbers.filter(n => {
          let rel = true;
          if(rNumber[0]>0)
          {
            if(n<0)
            rel=false
          }
          else if(rNumber[0]<0)
          {
            if(n>0)
            rel=false
          }
          // for(let rIndex2=1;rIndex2<=rIndex;rIndex++)
          // {
          //   if(rNumber[0]>0)
          //   {
          //     if(rNumber[rIndex]<0)
          //     rel=false;
          //   }
          //   else if(rNumber[0]<0)
          //   {
          //     if(rNumber[rIndex]>0)
          //     rel=false;
          //   }
          // }
          return rel;

        })
        numbers = numbers.filter(n => {
          let tnumbers = _this.getNumbersForLB(nTotal[rIndex] + n, next2, 0, type);
          tnumbers = _this.filterNumbersWithList(nTotal[rIndex] + n, formulaList, tnumbers);
          //console.log(tnumbers);
          return tnumbers.length > 0 ? true : false;
          //return nTotal+n<5&&nTotal+n>=0&&nTotal+n>=-4-next2;
        })

        if (nIndex == 0) {
          numbers = numbers.filter(n => n > 0);
        }
      //  console.log(nTotal[rIndex],nTotal[rIndex-1]);
        if((type=='BB'||type=='L&B')&&largerThan==0&&digits==rIndex+1)
        {
          // if(vposition==rIndex-1)
          // {
          //  console.log(numbers,nTotal[rIndex-1],next01);
          if(next02!=0)
          {
          //  console.log("test2",numbers,rNumber[0]);
            numbers = numbers.filter(n => (nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<80||n<=0));
            if(numbers.length>=2)
            {
              numbers = numbers.filter(n => n!=0);
            }
          //  console.log("test22",numbers);
          }
          else
          if(next01!=0)
          {
          //  console.log("test3",numbers,rNumber[0]);
            numbers = numbers.filter(n => (nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<90||n<=0));
            if(numbers.length>=2)
            {
              numbers = numbers.filter(n => n!=0);
            }
          //  console.log("test32",numbers,rNumber[0]);
          }
          else
          {
            numbers = numbers.filter(n => (nTotal[rIndex-1]+next01+(nTotal[rIndex]+n)*10<100)||n<=0);
            if(numbers.length>=2)
            {
              numbers = numbers.filter(n => n!=0);
            }
          }

          //  console.log(numbers);
          //}
          //console.log('larger');
          // console.log("||||||||||||")
          // numbers = numbers.filter(n => {
          //   console.log(n,nTotal[rIndex-1],(nTotal[rIndex]+n)*10,nTotal[rIndex-1]+(nTotal[rIndex]+n)*10);
          //     console.log("-------")
          //   return nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<100});
        //numbers = numbers.filter(n => nTotal[rIndex]+n <9);
        }
        rNumber[rIndex] = _.sample(numbers);
        nTotal[rIndex] += rNumber[rIndex];
      }

      // let temp_total=total-rNumber;
      // if(nIndex==rows-1)
      // {
      //   rNumber = total;
      // }
      // else
      // while(temp_total>=maxNumber||temp_total<=-maxNumber)
      // {
      //   rNumber = _.random(-maxNumber+1,maxNumber-1);
      //   temp_total=total-rNumber;
      // }
      // total=temp_total;
      let finalNumber = rNumber[0];
      //console.log(finalNumber,rNumber);
      if(digits>=2)
      {
        finalNumber = rNumber[0]*Math.pow(10,vposition);

        for(let rIndex=1;rIndex<digits;rIndex++)
        {
          if(rIndex-1<vposition)
          finalNumber += rNumber[rIndex]*Math.pow(10,rIndex-1);
          else {
            finalNumber += rNumber[rIndex]*Math.pow(10,rIndex);
          }
        }
      }

      // if (digits == 2) {
      //   finalNumber = rNumber2 * 10 + rNumber;
      //   if (vposition == 1)
      //     finalNumber = rNumber * 10 + rNumber2;
      //   //console.log(rNumber2,rNumber);
      // }
      // if (digits == 3) {
      //   finalNumber = rNumber3 * 100 + rNumber2 * 10 + rNumber;
      //   if (vposition == 1)
      //     finalNumber = rNumber3 * 100 + rNumber * 10 + rNumber2;
      //   if (vposition == 2)
      //     finalNumber = rNumber * 100 + rNumber3 * 10 + rNumber2;
      //   //console.log(rNumber2,rNumber);
      // }
      // if (digits == 4) {
      //   finalNumber = rNumber4 * 1000 + rNumber3 * 100 + rNumber2 * 10 + rNumber;
      //   if (vposition == 1)
      //     finalNumber = rNumber4 * 1000 +rNumber3 * 100 + rNumber * 10 + rNumber2;
      //   if (vposition == 2)
      //     finalNumber = rNumber4 * 1000 +rNumber * 100 + rNumber3 * 10 + rNumber2;
      //     if (vposition == 3)
      //       finalNumber = rNumber * 1000 +rNumber4 * 100 + rNumber3 * 10 + rNumber2;
      //   //console.log(rNumber2,rNumber);
      // }
      // if (digits == 5) {
      //   finalNumber = rNumber5 * 10000 +rNumber4 * 1000 + rNumber3 * 100 + rNumber2 * 10 + rNumber;
      //   if (vposition == 1)
      //     finalNumber = rNumber5 * 10000 +rNumber4 * 1000 + rNumber3 * 100 + rNumber * 10 + rNumber2;
      //   if (vposition == 2)
      //     finalNumber = rNumber5 * 10000 +rNumber4 * 1000 + rNumber * 100 + rNumber3 * 10 + rNumber2;
      //   if (vposition == 3)
      //     finalNumber = rNumber5 * 10000 +rNumber * 1000 + rNumber4 * 100 + rNumber3 * 10 + rNumber2;
      //     if (vposition == 4)
      //       finalNumber = rNumber * 10000 +rNumber5 * 1000 + rNumber4 * 100 + rNumber3 * 10 + rNumber2;
      //   //console.log(rNumber2,rNumber);
      // }
    //  console.log(finalNumber);
      if (finalNumber != undefined && !isNaN(finalNumber))
        item.numbers.push(finalNumber);
      else {
      //  console.log('undefined', nTotal);
        // item.numbers=[];
        // nIndex=-1;
        //  nTotal = 0;
        // nTotal2 = 0;
        return _this.generateItemForLB2(item,lbNumb,type);
        //item.numbers.push(finalNumber);
      }
      total += finalNumber;
    }
    item.result = total;
    //  console.log(total);
  }



  randomQuestionList(number = 1) {

    let questions = [];
    let { type, maxNumber, rows, digits,digits1,digits2,dr1,dr2,dba,roundNumber } = _this.state;
    if (!type) {
      alert("Please select type");
      return;
    }
    if (rows < 3 || rows > 100) {
      alert("Rows need to be between 3 and 100");
      return;
    }
    let index;
    for (index = 0; index < number; index++) {
      let item = { type: "image" };
      if (type.length > 0) {
        item = { type: _.sample(type) };
      //  item = { type: 'L&B_-9.2' };
      }
      if (item.type == "soroban") {
        item.result = _.random(Math.pow(10,digits-1),Math.pow(10,digits)-1);
      }
      else if (item.type == "image") {
        item.result = _.random(9);
        if(digits>1)
        {
          item.result = _.random(10,99);
          if(roundNumber)
          {
            item.result = _.random(1,9)*10;
          }
        }


        item.images = [];
        if (item.result >= 10) {
          item.images.push("assets/images/finger/" + Math.floor(item.result / 10) + "0-01.png");
        }
        if(item.result < 10||roundNumber==0||roundNumber==false)
        {
          item.images.push("assets/images/finger/" + item.result % 10 + "-01.png");
        }

      }
      else if(item.type=="multiple")
      {

        let d1 = _.random(Math.pow(10,digits1-1),Math.pow(10,digits1)-1);
        if(roundNumber)
        {
          d1 = _.random(1,9)*Math.pow(10,digits1-1);
        }
        let d2 = _.random(Math.pow(10,digits2-1),Math.pow(10,digits2)-1);
        if(roundNumber)
        {
          d2 = _.random(1,9)*Math.pow(10,digits2-1);
        }
        if(dr1!=0&&dr2!=0)
        {
          d2 = _.random(dr1,dr2);
        }

        item.numbers = [d1,"x"+d2];
         item.result = d1*d2;
      }
      else if(item.type=="divide")
      {
        let d1 = _.random(Math.pow(10,digits1-1),Math.pow(10,digits1)-1);
        if(roundNumber)
        {
          d1 = _.random(1,9)*Math.pow(10,digits1-1);
        }
        let d2 = _.random(Math.pow(10,digits2-1),Math.pow(10,digits2)-1);
        if(roundNumber)
        {
          d2 = _.random(1,9)*Math.pow(10,digits2-1);
        }
        if(dr1!=0&&dr2!=0)
        {
          d2 = _.random(dr1,dr2);
        }

        if(parseInt(dba)==1)
        {

            let index=1;
            let nList =[];
            while (index)
            {
              if(d2*index<Math.pow(10,digits1)-1 )
              {
                if(d2*index >=Math.pow(10,digits1-1))
                nList.push(d2*index);
                index++;
              }
              else {
                break;
              }
            }
          d1=_.sample(nList);
        }

        item.numbers = [d1,"÷"+d2];
         item.result = d1/d2;
      }

      else {
      //  console.log(item.type);
        let type = item.type.split('_');
        if (type.length > 1) {
          let fDigit = parseInt(type[1]);
          let fType = type[0];
          // if(fType=="LB")
          // {
          _this.generateItemForLB2(item, fDigit, type[0]);
          //}
        }


      }
      //console.log(item.numbers,item.result);
      questions.push(item);
    }
    return questions;
  }
  isShowEnd() {
    _this.setState({ showing: false, showCountDown: _this.state.trial?false:true }, () => {
      if (!isMobileDevice()) {
        _this.answerInput.focus();
      }
    });
    //console.log("start countdown");
  }
  endCountDown() {
    //console.log("end coutdown");
    _this.confirmAnswer();
  }
  progressQuestion() {
    _this.setState({showEQMessage:'',answering:false});
    let q = _this.state.questions[_this.state.curIndex];
    if (q.type == "image"||q.type=="soroban") {
      _this.setState({ showCountDown: true }, () => {
        if (!isMobileDevice()) {
          _this.answerInput.focus();
        }
      });
    }
    else {
      _this.setState({ showCountDown: false, showing: true });
    }
  }
  getShowEQ(cIndex) {
    let rel = '';
    let q = _this.state.questions[_this.state.curIndex];
    if (q.type == 'multiple' || q.type=='divide') {
      let numbers = q.numbers;
      let pre = '+'
      let index = 0;
      if (numbers)
        for (index; index <= cIndex; index++) {
          if (index == 0) {
            rel += numbers[index];
          }
          else {
            // if (numbers[index - 1] < 0 && numbers[index] > 0) {
            //   rel += ' +' + numbers[index];
            // }
            // else {
            //   rel += ' ' + numbers[index];
            // }

              rel += ' ' + numbers[index];

          }
          if (index == numbers.length - 1) {
            rel += " = ";
          }
        }
    }
    else
    if (q.type != 'image') {
      let numbers = q.numbers;
      //console.log(numbers,rel);

      let pre = '+'
      let index = 0;
      if (numbers)
        for (index; index <= cIndex; index++) {
          if (index == 0) {
            rel += numbers[index].toString();
          }
          else {
            // if (numbers[index - 1] < 0 && numbers[index] > 0) {
            //   rel += ' +' + numbers[index];
            // }
            // else {
            //   rel += ' ' + numbers[index];
            // }
            if (numbers[index] > 0) {
              rel += ' + ' + numbers[index];
            }
            else {
              rel += ' - ' + Math.abs(numbers[index]);
            }
          }
          if (index == numbers.length - 1) {
            rel += " = ";
          }
          //console.log(rel);
        }
    }
    return rel;

  }
  confirmAnswer() {
    if (!_this.state.starting)
      return;
    if(_this.state.answering)
    return;
    _this.setState({answering:true});
    let q = _this.state.questions[_this.state.curIndex];
    let answer = _this.state.answerInput;
    if (q.result == parseInt(answer)) {
      q.status = 1;
    }
    else {
      q.status = 0;
    }
    q.answer = answer;
    let message = (<span style={{ color: "#fff8ad", fontSize: '10rem' }}><DoneIcon style={{ fontSize: '10rem' }} /></span>);
    if (q.status == 0) {
      message = (<span style={{ color: "red", fontSize: '10rem' }}>X</span>);
      if(store.getState().SOUND==1)
      {
        _this.state.fAudio.currentTime=0;
  _this.state.fAudio.play();
      }

    }
    else {
      if(store.getState().SOUND==1)
      {
      _this.state.sAudio.currentTime=0;
_this.state.sAudio.play();
}
    }
    _this.setState({showEQMessage:_this.state.showEQMessage+q.result});


    _this.setState({ showCountDown: false, message, answerInput: '' });
    let curIndex = _this.state.curIndex;
    if (curIndex < _this.state.questions.length - 1)
      setTimeout(function() {
        _this.setState({answering:false, curIndex: curIndex + 1, answerInput: '', message: '' }, () => _this.progressQuestion());
      }, 2000);
    else {
      if (_this.state.starting) {
        message = (<span style={{ color: "#fff8ad", fontSize: '5rem' }}>{!_this.state.trial?"Bravo!!":false}</span>);
        if(store.getState().SOUND==1&&!_this.state.trial)
        {
          _this.state.yAudio.currentTime=0;
    _this.state.yAudio.play();
        }
        setTimeout(function() {
          _this.setState({answering:false, message, answerInput: '', starting: false });
          if (_this.props.onLessonEnd && !_this.state.trial) {
            if(_this.props.group)
            _this.state.questions.group=_this.props.group;
            _this.props.onLessonEnd(_this.state.questions);
          }
        }, 2000);
      }
      else {
        setTimeout(function() {
          _this.setState({answering:false, message: '', answerInput: '', questions: [] });
        }, 2000);
      }


    }


  }
  getFormularName() {
    let { type } = _this.state;
    if(_this.props.showTypeText)
    return _this.props.showTypeText;
    let rel = '';
    if (type && type.length > 0) {
      let tObj = _.find(typeList, { value: type[0] });
      if (tObj) {
        rel = tObj.label;
      }
    }
    return rel;
  }
  updateEQMessage(index) {
    _this.setState({ showEQMessage: _this.getShowEQ(index) })
  }
  handleChangeTypeCat = event => {

    event.preventDefault();
    let typeCat = event.target.value;

    let tObj = _.find(typeCatList, { value: typeCat });
    if (tObj) {

      _this.setState({ type: [tObj.childs[0].value] });
    }



  }
  handleChangeType = event => {

    event.preventDefault();
    //let type = [event.target.value];



    _this.setState({ type: [event.target.value] });




  }
  getTypeCatForType(type) {

    for (let catType of typeCatList) {
      let tObj = _.find(catType.childs, { value: type })
      if (tObj) {
        return catType.value;
      }
    }
    return '';
  }
  getSorobanImages(numb,width){
    let tArr = numb.toString().split('');
    let bWidth = width*0.7/7;
    let n=6;
    let bStyle = {width:bWidth,height:bWidth*0.53}
    let rel= (<div style={{display:'flex',flexDirection:'row'}}>
      {tArr.map((n,index)=>{
        return (<div key={index} style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
          <div style={bStyle}>

          </div>
          <div style={bStyle}>
            {n>=5?<img
                src="assets/images/soroban/soroban.png"
                style={bStyle} />:false}
          </div>
          <div
            style={{position: 'relative',lineHeight:0}}>
            <img
            src="assets/images/soroban/sline.png"
            style={{width: bWidth, height: bWidth*0.11}} />
          {index==tArr.length-1?<div style={{position: 'absolute', top: 0, width: '100%', textAlign: 'center'}}>
            <img
            src="assets/images/soroban/dot.png"
            style={{width: 'auto', height: bWidth*0.078}} />
        </div>:false}
            </div>
            <div style={bStyle}>
              {n%5>=1?<img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} />:false}
            </div>
            <div style={bStyle}>
              {n%5>=2?<img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} />:false}
            </div>
            <div style={bStyle}>
              {n%5>=3?<img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} />:false}
            </div>
            <div style={bStyle}>{n%5>=4?<img
                src="assets/images/soroban/soroban.png"
                style={bStyle} />:false}
            </div>
            <div style={bStyle}>
            </div>

        </div>);
      })}
    </div>);


return rel;

  }

  render() {
    const { classes,t,pWidth } = this.props;
    const { wWidth, wHeight, answerInput,enableSound,minDigits,maxDigits,ssp,showSSP, type, rows, lessThan0, showTime, answerTime, qCount, digits, digits1, digits2, maxNumber, showing, questions, curIndex, showEq, message, starting, showCountDown, displayShow, displaySetting, showEQMessage } = this.state;
    let width = DWIDTH - 10;
    if (wWidth < DWIDTH) {
      width = wWidth - 10;
    }
    // if(pWidth)
    // width = pWidth;

    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let typeCat = '';
    if (type && type.length > 0) {
      typeCat = this.getTypeCatForType(type[0]);
    }
    //console.log("display",displaySetting);
    //console.log(width);
    let digitsArr = [];
    if(minDigits && maxDigits)
    {
      for(let i = 1; i<=maxDigits;i++)
      {
        digitsArr.push(i);
      }
    }
    return (



      <div>
        <Grid container direction="row" justify="center" style={{ marginTop: 5 }}>
          {questions.length > 0 ? <Grid item xs={12} style={{ width: "80%" }}>
            <p style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', margin: 0, fontSize: fTitle, textAlign: 'center', width: "100%", borderRadius: "4px" }}>{curIndex + 1 + '/' + questions.length} {t('common.sentences')} {/*&nbsp;&nbsp;&nbsp;&nbsp;{/*{digits}D/{rows}R/{this.getFormularName()}*/}</p>
          </Grid> : false}
          <Grid item xs={12} sm={8} >
            <Grid container alignItems="center" justify="center" style={{ border: 2, borderRadius: 10, width: '100%', height: width>=600?width * 0.8:width * 0.6, backgroundColor: "#65a343", position: 'relative' }} >
              <div style={{ position: 'absolute', width: '100%', top: STATIC.calSize(5, STATIC.DWIDTH, width), left: STATIC.calSize(5, STATIC.DWIDTH, width) }}>
                <img
                  src="assets/web/logo_trans.png"
                  style={{ maxWidth: 296, height: 'auto', width: STATIC.calSize(160, STATIC.DWIDTH, width) }} />
              </div>


              {message ? <Grid item >
                {message}
              </Grid> :
                questions.length > 0 ? questions[curIndex].type == 'soroban'?<Grid item >{this.getSorobanImages(questions[curIndex].result,width)}</Grid>:questions[curIndex].type != 'image' ? <Grid item ><NumDisplay width={width} type={questions[curIndex].type} second={showTime} sound={store.getState().SOUND==1&&this.state.enableSound} numbers={questions[curIndex].numbers} showing={showing} updateEQMessage={this.updateEQMessage} isEnd={this.isShowEnd} /></Grid> : questions[curIndex].images.map((image, index) => {
                  return (<Grid item key={"image" + index} >
                    <img src={image} style={{ width: width * 0.3 }} />
                  </Grid>)
                }) : false}


            </Grid>
            <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
              {showEq ? <p style={{ backgroundColor: "white", color: 'rgb(5, 63, 34)', marginTop: 0, flexGrow: 1, borderRadius: "4px", fontSize: fNormal, minHeight: STATIC.calSize(60, STATIC.DWIDTH, width) }}>{showEQMessage}</p> : <div style={{ flexGrow: 1 }}></div>}
              {displayShow ? <div><Button style={{ color: "white", backgroundColor: '#65a343', fontSize: fNormal, padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(8, STATIC.DWIDTH, width) + 'px') }} color="primary" size="large" variant="contained" onClick={() => this.setState({ showEq: !this.state.showEq })}  >
                {t('common.show')}
                                      </Button></div> : false}
            </Grid>

          </Grid>
          <Grid item xs={12} sm={4} style={{ marginTop: 10 }}>
            <Grid container direction="row" alignItems="center" justify="center">


              <Grid container direction="row" justify="space-between">
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={8} style={{ textAlign: "right", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ marginRight: 10, color: "#053f22", fontSize: fNormal }}>{t('common.answer')}:</div>
                  <input ref={(input) => { this.answerInput = input; }} type="number" onKeyPress={this.handleKeypress} onKeyDown={e=> {if(e.keyCode==69) e.preventDefault();}} onChange={this.handleChange("answerInput")} disabled={showing ? true : false} value={answerInput} style={{ flex: 1, textAlign: 'center',fontSize:20, backgroundColor: "white", border: "1px #053f1e solid", width: "100%", borderRadius: "4px", height: STATIC.calSize(70, STATIC.DWIDTH, width), marginRight: STATIC.calSize(10, STATIC.DWIDTH, width) }} />
                </Grid>

                <Grid item xs={3} style={{ textAlign: "right", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  {!starting ? <Button style={{ color: "#053f22", padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', float: "right", fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.startLesson()}>
                    {t('common.start')}
                                              </Button> : false}
                </Grid>

              </Grid>
              {showCountDown ? <Grid container alignItems="center" justify="center"><Grid item style={{ color: 'rgb(5, 63, 34)', fontSize: fNormal }}>
                {t('common.remain_time')}: <CountDown size={fNormal} second={answerTime} isEnd={this.endCountDown} />
              </Grid></Grid> : false}

              <Grid item style={{ marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <Numpad width={width * 0.4} handleClick={this.handleInputClick} />
              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="row" style={{ marginTop: STATIC.calSize(10, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <Grid item xs={12} style={{ textAlign: 'left' }}>

                {!starting&&displaySetting ? <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal, alignSelf: 'flex-start' }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showSetting: true })}>
                  {t('common.setting')}
                                      </Button> : false}
                                      {this.props.showAdvance&&!starting ? <Button style={{ color: "#053f22", marginLeft: STATIC.calSize(25, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showSetting: false,rows:rows&&rows>=3?rows:3,digits1:digits1&&digits1>=minDigits?digits1:minDigits,digits2:digits2&&digits2>=minDigits?digits2:minDigits }, () => this.startTrial())}>
                                        {t('common.try')}
                                                            </Button> : false}

              </Grid>


            </Grid>
          </Grid>




        </Grid>

        <Modal styles={{ modal: { minWidth: width * 0.8, textAlign: 'center', background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={this.state.showSetting} onClose={() => this.setState({ showSetting: false ,rows:rows&&rows>=3?rows>40?40:rows:3},()=>_this.updateTitle())} center>
          <div style={{ width: width * 0.8, backgroundColor: 'rgba(141, 198, 63, 0.8)', position: 'relative', borderRadius: 10, padding: 10 }}>
            {this.props.showTypeImage?<div style={{display:'flex',justifyContent:'center'}}><img src={this.props.showTypeImage} style={{width:width*0.2}} /></div>:this.props.showTypeText?<div style={{textAlign:'center',fontSize:fLarge,color: 'rgb(5, 63, 34)'}}>{this.props.showTypeText}</div>:false}

            {type.length>0&&type[0]!="image"&&type[0]!="multiple"&&type[0]!="divide"?<fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <Grid container direction="column" alignItems="center" justify="center">
                  <Grid item >
                    <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)' }}>
                      <span style={{ fontSize: fNormal }}>{t('common.digits')} </span>
                    </div>
                    <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', width: width * (digitsArr.length*0.07) }}>
                      {digitsArr.map((t, index) => {
                        return (<div key={index} style={{display:'inline-block'}}><ButtonBase onClick={()=>_this.setState({digits:t})} focusRipple style={{ color: "rgb(5, 63, 34)",marginRight: STATIC.calSize(5, STATIC.DWIDTH, width),position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(5, STATIC.DWIDTH, width), width: width*0.06,height:width*0.06 ,backgroundColor:digits==t?'#FFCD34':'#EFE58F', }} color="primary" size="large" variant="contained"  >

                          <div style={{fontSize:fTitle}}>{t}</div>
                        </ButtonBase></div>)
                      })}
                    </div>
                  </Grid>
                  <Grid item  style={{marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>
                    <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)' }}>
                      <span style={{ fontSize: fNormal }}>{t('common.rows')} </span>
                    </div>
                    <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', marginLeft: 5, width: width * 0.15 }}>
                      <input
                        onChange={this.handleChangeDigits('rows',40)}
                        value={rows}
                        type="number"
                        min={3}
                        max={40}
                        placeholder=""
                        style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                    </div>

                  </Grid>
                </Grid>
              </fieldset>:false}
              {type.length>0&&(type[0]=="multiple"||type[0]=="divide")?<fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <Grid container direction="column" alignItems="center" justify="center">
                <Grid item xs >
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)' }}>
                    <span style={{ fontSize: fNormal }}>{t('common.digits')} </span>
                  </div>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', width: width * 0.15 }}>
                    <input
                      onChange={this.handleChangeDigits('digits1',this.state.maxDigits)}
                      value={digits1}
                      type="number"
                      min={this.state.minDigits}
                      max={this.state.maxDigits}
                      placeholder=""
                      style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                  </div>
                  <div style={{ display: 'inline-block', marginLeft: 5, marginRight: 5, color: 'rgb(5, 63, 34)' }}>
                    <span style={{ fontSize: fNormal }}>{type[0] == 'multiple' ? "x" : "÷"}</span>
                  </div>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', width: width * 0.15 }}>
                    <input
                      onChange={this.handleChangeDigits('digits2',this.state.maxDigits)}
                      value={digits2}
                      type="number"
                      min={this.state.minDigits}
                      max={this.state.maxDigits}
                      placeholder=""
                      style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                  </div>

                </Grid>
              </Grid>
            </fieldset>:false}
            <fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fNormal, color: 'rgb(5, 63, 34)' }}>{t('common.timers')}</legend>
              <Grid container direction="column" alignItems="center" justify="center">

                  {showTimeList.map((t, index) => {
                    return (<Grid key={index} item style={{marginBottom:STATIC.calSize(5, STATIC.DWIDTH, width)}}><ButtonBase onClick={()=>_this.setState({showTime:t.value})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(5, STATIC.DWIDTH, width), width: width*0.6,height:STATIC.calSize(40, STATIC.DWIDTH, width) ,backgroundColor:showTime==t.value?'#FFCD34':'#EFE58F', }} color="primary" size="large" variant="contained"  >

                      <div style={{fontSize:fTitle}}>{t.value}</div>
                    </ButtonBase></Grid>)
                  })}

              </Grid>
            </fieldset>
            <fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fNormal, color: 'rgb(5, 63, 34)' }}>{t('common.question_group')}</legend>
              <Grid container direction="row" alignItems="center" justify="center">
                <Grid item>
                  <FormControl style={{ width: width * 0.2 }}>

                    <Select
                      value={qCount}
                      onChange={this.handleChange('qCount')}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {qCountList.map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl style={{ width: width * 0.2, marginLeft: 5 }}>

                    <Select
                      value={answerTime}
                      onChange={this.handleChange('answerTime')}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {answerTimeList.map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </fieldset>
            <div style={{ display: 'flex', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
              <div style={{ marginLeft: 'auto' }}>

              <Button style={{ color: "#053f22", width: STATIC.calSize(64, STATIC.DWIDTH, width), height: STATIC.calSize(64, STATIC.DWIDTH, width), padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: this.state.enableSound ? '#fdce07' : 'gray', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => STATIC.NotificationManager.info("Chức năng này đang nâng cấp")}>
                  <img
                    src="assets/web/icon_ear.png"
                    style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                </Button>
                {/* <Button style={{ color: "#053f22", width: STATIC.calSize(64, STATIC.DWIDTH, width), height: STATIC.calSize(64, STATIC.DWIDTH, width), padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: this.state.enableSound ? '#fdce07' : 'gray', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ enableSound:!enableSound })}>
                  <img
                    src="assets/web/icon_ear.png"
                    style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                </Button> */}
                {/*<Button style={{ color: "#053f22", marginLeft: 5, width: STATIC.calSize(64, STATIC.DWIDTH, width), height: STATIC.calSize(64, STATIC.DWIDTH, width), padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: this.state.displayShow ? '#fdce07' : 'gray', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ displayShow:!displayShow })}>
                  <img
                    src="assets/web/icon_eye.png"
                    style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                </Button>*/}
              </div>
            </div>

            <div style={{ display: 'flex', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
              <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showSetting: false,rows:rows&&rows>=3?rows:3,digits1:digits1&&digits1>=minDigits?digits1:minDigits,digits2:digits2&&digits2>=minDigits?digits2:minDigits }, () => {this.startTrial();
                if(this.props.onChangeFormula)
                {
                  this.props.onChangeFormula(this.state);
                }
              })}>
                {t('common.try')}
                                    </Button>
              <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal, marginLeft: 'auto' }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showSetting: false,rows:rows&&rows>=3?rows:3,digits1:digits1&&digits1>=minDigits?digits1:minDigits,digits2:digits2&&digits2>=minDigits?digits2:minDigits }, () => {this.updateTitle();
                if(this.props.onChangeFormula)
                {
                  this.props.onChangeFormula(this.state);
                }

              })}>
                {t('common.save')}
                                          </Button>

            </div>
          </div>
        </Modal>
        <Modal styles={{ modal: { minWidth: width * 0.8, textAlign: 'center', background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={this.state.showSetting2} onClose={() => this.setState({ showSetting2: false })} center>
          <div style={{ width: width * 0.8, backgroundColor: 'rgba(141, 198, 63, 0.8)', position: 'relative', borderRadius: 10, padding: 10 }}>
            <fieldset style={{ borderColor: 'white', borderRadius: 10 }}>
              <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fNormal, color: 'rgb(5, 63, 34)' }}>Formula</legend>
              <Grid container direction="column" alignItems="center" justify="center">
                <Grid item xs={12} style={{ width: '80%' }}>
                  <FormControl style={{ width: '100%' }}>

                    <Select
                      value={typeCat}
                      onChange={this.handleChangeTypeCat}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {typeCatList.map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>


                </Grid>
                {type && (type[0] != 'multiple' && type[0] != 'divide') ? (<Grid item xs={12} style={{ width: '80%', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <FormControl style={{ width: '100%' }}>

                    <Select
                      value={type}
                      onChange={this.handleChangeType}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {typeList.filter(t=>this.getTypeCatForType(t.value)==typeCat).map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>


                </Grid>) : (<Grid item xs={12} style={{ marginTop: STATIC.calSize(10, STATIC.DWIDTH) }}>
                  <Grid container direction="column" alignItems="center" justify="center">
                    <Grid item xs >
                      <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)' }}>
                        <span style={{ fontSize: fNormal }}>Digit(s)</span>
                      </div>
                      <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', width: width * 0.15 }}>
                        <input
                          onChange={this.handleChangeDigits('digits1',5)}
                          value={digits1}
                          type="number"
                          min={1}
                          max={5}
                          placeholder=""
                          style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                      </div>
                      <div style={{ display: 'inline-block', marginLeft: 5, marginRight: 5, color: 'rgb(5, 63, 34)' }}>
                        <span style={{ fontSize: fNormal }}>{type[0] == 'multiple' ? "x" : "÷"}</span>
                      </div>
                      <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', width: width * 0.15 }}>
                        <input
                          onChange={this.handleChangeDigits('digits2',5)}
                          value={digits2}
                          type="number"
                          min={1}
                          max={5}
                          placeholder=""
                          style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                      </div>

                    </Grid>
                  </Grid>

                  </Grid>)}

              </Grid>
            </fieldset>
            {type && (type[0] != 'multiple' && type[0] != 'divide') ? <fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <Grid container direction="column" alignItems="center" justify="center">
                <Grid item xs>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)' }}>
                    <span style={{ fontSize: fNormal }}>Digit(s) </span>
                  </div>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', marginLeft: 5, width: width * 0.15 }}>
                    <input
                      onChange={this.handleChangeDigits('digits',type[0] != 'soroban'?3:7)}
                      value={digits}
                      type="number"
                      min={1}
                      max={type[0] != 'soroban'?3:7}
                      placeholder=""
                      style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                  </div>

                </Grid>
                <Grid item xs>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)' }}>
                    <span style={{ fontSize: fNormal }}>Row(s) </span>
                  </div>
                  <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', marginLeft: 5, width: width * 0.15 }}>
                    <input
                      onChange={this.handleChangeDigits('rows',40)}
                      value={rows}
                      type="number"
                      min={3}
                      max={40}
                      placeholder=""
                      style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                  </div>

                </Grid>
              </Grid>
            </fieldset> : false}
            <fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fNormal, color: 'rgb(5, 63, 34)' }}>Question</legend>
              <Grid container direction="row" alignItems="center" justify="center">
                <Grid item>
                  <FormControl style={{ width: width * 0.2 }}>

                    <Select
                      value={qCount}
                      onChange={this.handleChange('qCount')}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {qCountList.map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl style={{ width: width * 0.2, marginLeft: 5 }}>

                    <Select
                      value={answerTime}
                      onChange={this.handleChange('answerTime')}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {answerTimeList.map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </fieldset>
            <fieldset style={{ borderColor: 'white', borderRadius: 10, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
              <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fNormal, color: 'rgb(5, 63, 34)' }}>Timer(s)</legend>
              <Grid container direction="row" alignItems="center" justify="center">
                <Grid item>
                  <FormControl style={{ width: width * 0.3 }}>

                    <Select
                      value={showTime}
                      onChange={this.handleChange('showTime')}

                      style={{ backgroundColor: 'white', border: 'none', color: 'rgb(5, 63, 34)', padding: 5, textAlign: 'left', fontSize: fNormal }}

                    >
                      {showTimeList.map((t, index) => {
                        return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </fieldset>
            <div style={{ display: 'flex', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
              <div style={{ marginLeft: 'auto' }}>

              <Button style={{ color: "#053f22", width: STATIC.calSize(64, STATIC.DWIDTH, width), height: STATIC.calSize(64, STATIC.DWIDTH, width), padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: this.state.enableSound ? '#fdce07' : 'gray', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => STATIC.NotificationManager.info("Chức năng này đang nâng cấp")}>
                  <img
                    src="assets/web/icon_ear.png"
                    style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                </Button>
                {/* <Button style={{ color: "#053f22", width: STATIC.calSize(64, STATIC.DWIDTH, width), height: STATIC.calSize(64, STATIC.DWIDTH, width), padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: this.state.enableSound ? '#fdce07' : 'gray', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ enableSound:!enableSound })}>
                  <img
                    src="assets/web/icon_ear.png"
                    style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                </Button> */}
                <Button style={{ color: "#053f22", marginLeft: 5, width: STATIC.calSize(64, STATIC.DWIDTH, width), height: STATIC.calSize(64, STATIC.DWIDTH, width), padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: this.state.displayShow ? '#fdce07' : 'gray', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ displayShow:!displayShow }, )}>
                  <img
                    src="assets/web/icon_eye.png"
                    style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                </Button>
              </div>
            </div>

            <div style={{ display: 'flex', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
              <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained"
                onClick={() => this.setState({ showSetting: false }, () => {this.startTrial();
                  if(this.props.onChangeFormula)
                  {
                    this.props.onChangeFormula(this.state);
                  }
                })}>
                {t('common.try')}
                                    </Button>
              <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width),
                padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal, marginLeft: 'auto' }} color="primary" size="medium" variant="contained"
                onClick={() => this.setState({ showSetting: false }, () => {this.updateTitle();

                  if(this.props.onChangeFormula)
                  {
                    this.props.onChangeFormula(this.state);
                  }

                })}>
                {t('common.save')}
                                          </Button>

            </div>

          </div>

        </Modal>
        <Modal styles={{overlay:{padding:0}, modal: { minWidth: width , background: 'none',textAlign:'center' } }} showCloseIcon={false} focusTrapped={false} open={showSSP} onClose={() => this.setState({ showSSP:false})} center>
          <div style={{ width: width*0.98, backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
            <div style={{ display: 'flex',flexDirection:'column' }}>


                <Grid container justify='center'>
                  <Grid xs={12} item>
                    <img
                      src="assets/web/ssp_icon.png"
                      style={{ height: 'auto', width: width * 0.6 }} />
                  </Grid>
                  <Grid xs={12} item>
                    <div style={{textAlign: 'center', fontSize: fLarge, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.ssp_alert')}</div>
                  </Grid>
                  <Grid item>
                    <Button disabled={this.state.loading} style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'),marginLeft:'auto', minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({showSSP:false})}>
                      {'OK'}
                          </Button>
                  </Grid>
                </Grid>
                </div>
              </div>
            </Modal>




      </div>


    );
  }
}

LessonComp.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(STATIC.translate('common')(LessonComp));
